import(/* webpackMode: "eager" */ "/app/src/components/News/ArticleList.tsx")